import { forwardRef } from 'react';
import { Icon } from './icon';
import type { IconProps } from './icon';
import type { Ref } from 'react';
export const ZoomOut = forwardRef(function ZoomOut(props: IconProps, ref: Ref<SVGSVGElement>) {
  return (
    <Icon {...props} ref={ref}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11 3.75a7.25 7.25 0 1 0 0 14.5 7.25 7.25 0 0 0 0-14.5ZM2.25 11a8.75 8.75 0 1 1 15.445 5.634l2.835 2.836a.75.75 0 0 1-1.06 1.06l-2.836-2.835A8.75 8.75 0 0 1 2.25 11ZM8 10.25a.75.75 0 0 0 0 1.5h6a.75.75 0 0 0 0-1.5H8Z"
        fill="currentColor"
      />
    </Icon>
  );
});
